<template>
    <div class="container-page py-10 md:py-14">
        <div class="card p-6 sm:p-10 md:p-14">
            <div class="grid gap-6 md:grid-cols-[220px_1fr] md:gap-12">
                <h2 class="section-title">About Me</h2>
                <p class="text-[19px] leading-[1.7] text-ink-2 sm:text-[21px]">
                    Backend Software Engineer focused on real-time systems, microservices, and scalable backend
                    architecture. Experienced in building APIs, processing data streams, and developing reliable
                    services with Python, FastAPI, Node.js, PostgreSQL, Redis, Docker, Kubernetes, and AWS. Interested
                    in solving complex backend problems and continuously improving system performance and reliability.
                </p>
            </div>
        </div>
    </div>
</template>
